/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react';
import { Stage, Layer } from 'react-konva';

import Brush from './Brush';

import SoundBanks from './SoundBanks';
const textures = SoundBanks[0];

function BrushStage (props) {
  const layerRef = useRef();
  const handleStageClick = () => {
  };

  const verticalDistance = 10;

  useEffect(() => {
    textures.forEach((texture) => {
      const id = 'Prelisten_' + texture.name;
      const gain = 0.3;
      props.samplePlayerRef.current.addSampler(id, texture, false, gain);
    });
  }, []);

  function handleClick (i) {
    const texture = textures[i];
    const id = 'Prelisten_' + texture.name;
    props.samplePlayerRef.current.monitorSample(id);
    props.selectTexture(i);
  }

  return (
    <Stage width={props.width} height={props.height} onClick={handleStageClick}>
        <Layer ref={layerRef}>
          {/* <Brush
            // ref={props.ref}
            selectedFormIndex={props.selectedFormIndex}
            selectedTextureIndex={props.selectedTextureIndex}
          /> */}

            {textures.map((texture, i) => (
                <Brush
                    x={props.width / 2 - (props.height / textures.length - verticalDistance) / 2}
                    y={i * (props.height / textures.length) + verticalDistance / 2}
                    height={props.height / textures.length - verticalDistance}
                    width={props.height / textures.length - verticalDistance}
                    key={i}
                    isSelected={i === props.selectedTextureIndex}
                    selectedFormIndex={props.selectedFormIndex}
                    selectedTextureIndex={i} // TODO: remove selected
                    fill= {texture.color.value}
                    onClick={() => handleClick(i)}
                    stroke={'red'}
                    strokeWidth={(i === props.selectedTextureIndex) ? props.strokeWidth : 0 }
                ></Brush>
            ))}

          </Layer>
      </Stage>
  );
};

export default React.memo(BrushStage);
